/**
 * Light/dark theme toggle. Adds/removes `.dark` on <html>; persists in localStorage.
 * Default = light (matches erp). Call applyTheme(getTheme()) before render to avoid flash.
 */
export type Theme = 'light' | 'dark'
const KEY = 'theme'

export function getTheme(): Theme {
  return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

export function setTheme(theme: Theme) {
  localStorage.setItem(KEY, theme)
  applyTheme(theme)
}
